<template>
    <v-card variant="outlined" class="my-4">
        <div class="appointment-row">
            <div class="appointment-icon">
                <v-icon size="20">mdi-calendar</v-icon>
            </div>
            <div class="appointment-content">
                <div class="appointment-title">
                    {{ startTime }} - {{ endTime }}, {{ date }}
                </div>
                <div class="appointment-subtitle">
                    {{ participantsText }}
                </div>
            </div>
        </div>
    </v-card>
</template>


<script>

export default {
    name: 'AppointmentCard',
    props: {
        appointment: Object,
    },
    components: {},

    data() {
        return {};
    },

    methods: {},

    computed: {
        startTime() {
            return new Date(this.appointment.StartTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
        },
        endTime() {
            return new Date(this.appointment.EndTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
        },
        date() {
            return new Date(this.appointment.StartTime).toLocaleDateString();
        },

        participantsText() {
            return this.appointment?.Participants?.map((item) => item.User.Name).join(", ");
        },
    },

    watch: {},
};
</script>


<style lang='scss' scoped>
.appointment-row {
    display: flex;
    align-items: center;
    min-height: 52px;
    padding: 8px 12px;
}

.appointment-icon {
    margin-right: 12px;
}

.appointment-content {
    min-width: 0;
    flex: 1;
}

.appointment-title {
    font-size: 14px;
    font-weight: 500;
    line-height: 1.25;
}

.appointment-subtitle {
    color: rgba(0, 0, 0, 0.6);
    font-size: 13px;
    line-height: 1.2;
}
</style>